import { CognitoUserPool, CookieStorage } from "amazon-cognito-identity-js";

const poolData = {
    UserPoolId : process.env.MIX_USER_POOL_COGNITO,
    ClientId : process.env.MIX_CLIENT_ID_COGNITO,
    Storage: new CookieStorage({domain: process.env.MIX_COOKIE_DOMAIN})
}
export default new CognitoUserPool(poolData);